import React from 'react';
import { PrimaryButton, SecondaryButton } from '../../../../shared/ui/Inputs';
import { OrderEnums } from '../../../../shared/constants/OrderEnums';
import { SimplePopup } from '../../../../shared/overlays';

const orderEnums = new OrderEnums();

interface CancelOrderPopupProps {
  order: any;
  errorMessage: string;
  setErrorMessage: (msg: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export const CancelOrderPopup: React.FC<CancelOrderPopupProps> = ({
  order,
  errorMessage,
  setErrorMessage,
  onClose,
  onConfirm,
}) => {
  const onSave = () => {
    if (
      orderEnums.status.isUnderAnalysis(order.status.id.toString()) &&
      order.number !== ''
    ) {
      setErrorMessage('');
      onConfirm();
    } else {
      if (orderEnums.status.isConcluded(order.status.id.toString())) {
        setErrorMessage(
          'O pedido não pode ser cancelado, pois ja foi concluído.'
        );
      } else if (orderEnums.status.isUnsuccessful(order.status.id.toString())) {
        setErrorMessage('O pedido selecionado já foi cancelado.');
      } else {
        setErrorMessage('Não foi possivel cancelar o pedido.');
      }
    }
  };

  return (
    <SimplePopup
      width={300}
      height={200}
      zIndex={1000}
      outlet={
        <div>
          <div
            style={{
              display: 'flex',
              marginBottom: '10px',
              boxSizing: 'border-box',
            }}
          >
            <div style={{ flex: 1 }}>
              <div className="order-text">Cancelar pedido</div>
              <br />
              <div className="subtext" style={{ fontSize: '16px' }}>
                Tem certeza que deseja cancelar o pedido de número{' '}
                {order.number}?
              </div>
            </div>
          </div>

          {errorMessage !== '' ? (
            <>
              <p>{errorMessage}</p>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '16px',
                }}
              >
                <div style={{ flex: 1, textAlign: 'center' }}>
                  <SecondaryButton onClick={onClose}>Ciente</SecondaryButton>
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '16px',
              }}
            >
              <div style={{ flex: 1, textAlign: 'center' }}>
                <SecondaryButton onClick={onClose}>Não</SecondaryButton>
              </div>
              <div style={{ flex: 1, textAlign: 'center' }}>
                <PrimaryButton onClick={onSave}>Sim</PrimaryButton>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
};
